import {
    GET_HOMEWORK_SUCCESS,
    GET_HOMEWORK_ERROR,
    GET_HOMEWORK_START,
    GET_EXERCISE_SUCCESS,
    GET_EXERCISE_ERROR,
    GET_EXERCISE_START,
    UPDATE_GEOGEBRA,
    RESET_GEOGEBRA,
} from '../actions/homework';

import { produce } from 'immer';
import { indexToLetter } from '../lib/utils';
import { SOURCES } from '../constants/sources';

export const initialState = {
    id: null,
    publicTitle: null,
    bookId: null,
    bookTitle: null,
    courseTitle: null,
    subjects: [],
    owner: null,
    creator: null,
    taxonomy: null,
    description: null,
    difficulty: null,
    avoidShuffle: false,
    levelType: null,
    ugc: null,
    authors: [],
    version: null,
    exercises: [],
    status: {
        seed: undefined,
        error: null,
        fetching: false,
        loaded: false,
    },
    assignmentId: '',
    endDate: null,
    time: '',
    geogebraExercises: [],
    idCat: null,
    isbn: null,
    catalogPaths: [],
    journey: null,
    phase: null,
};

export const reducer = produce((state = initialState, action = {}) => {
    switch (action.type) {
        case GET_EXERCISE_START:
            return {
                ...state,
                status: { ...state.status, fetching: true },
            };
        case GET_EXERCISE_SUCCESS:
            return {
                ...state,
                exercises: [action.payload.exercise],
                status: { ...state.status, fetching: false, loaded: true, seed: action.payload.random },
            };
        case GET_EXERCISE_ERROR:
        case GET_HOMEWORK_ERROR:
            return {
                ...state,
                status: { ...state.status, error: action.payload.error, fetching: false },
            };
        case GET_HOMEWORK_START:
            return {
                ...state,
                status: { ...state.status, fetching: true, loaded: false },
            };
        case GET_HOMEWORK_SUCCESS: {
            const data = action.payload.homework;
            const source = action.payload.source;
            const sections = action.payload.sections;

            let sectionsExercisesCounts;
            let curSectionIndex;
            let firstExerciseIndexInSection;
            let exercisesNumberThreshold;
            if (sections) {
                sectionsExercisesCounts = sections.map((section) => section.exercisesCount);
                curSectionIndex = 0;
                firstExerciseIndexInSection = 0;
                exercisesNumberThreshold = sectionsExercisesCounts[0];
            }

            if (source === SOURCES.ZTE_UNITUTOR && data.exercises.find((e) => e.sharedtextNodeId)) {
                const groupedData = {};
                data.exercises.forEach((exe, index) => {
                    if (sections && index >= exercisesNumberThreshold) {
                        firstExerciseIndexInSection = index;
                        exercisesNumberThreshold += sectionsExercisesCounts[++curSectionIndex];
                    }

                    if (exe.sharedtextNodeId) {
                        let relativeIndex;

                        if (sections) {
                            relativeIndex = index - firstExerciseIndexInSection;
                        } else {
                            relativeIndex = index;
                        }

                        if (groupedData[exe.sharedtextNodeId]) {
                            groupedData[exe.sharedtextNodeId].push(relativeIndex + 1);
                        } else {
                            groupedData[exe.sharedtextNodeId] = [relativeIndex + 1];
                        }
                    }
                });
                const uniqueSharedTextIds = [
                    ...new Set(data.exercises.filter((exercise) => exercise.sharedtextNodeId).map((obj) => obj.sharedtextNodeId)),
                ];
                data.exercises.forEach((exe) => {
                    if (exe.sharedtextNodeId && groupedData[exe.sharedtextNodeId].length > 1) {
                        exe.sharedText.title = `Testo ${indexToLetter(
                            uniqueSharedTextIds.indexOf(exe.sharedtextNodeId),
                        )} - relativo ai quiz ${groupedData[exe.sharedtextNodeId].map((i) => ` ${i}`)} `;
                    }
                });
            }
            return {
                ...state,
                authors: data.authors,
                avoidShuffle: data.avoidShuffle,
                bookId: data.bookId,
                bookTitle: data.bookTitle,
                courseTitle: data.courseTitle,
                decoratedExercises: data.decoratedExercises,
                description: data.description,
                difficulty: data.difficulty,
                exercises: data.exercises,
                id: data._id,
                levelType: data.levelType,
                owner: data.owner,
                creator: data.creator,
                publicTitle: data.publicTitle,
                status: { ...state.status, fetching: false, loaded: true },
                subjects: data.subjects,
                taxonomy: data.taxonomy,
                ugc: data.UGC,
                version: data.version,
                idCat: data.idCat,
                isbn: data.isbn,
                catalogPaths: data.catalogPaths,
                journey: data.journey,
                phase: data.phase,
            };
        }
        case UPDATE_GEOGEBRA:
        case RESET_GEOGEBRA: {
            let updatedGeogebraExercises = state.geogebraExercises.filter((item) => item.id !== action.payload.id);
            const receivedObject = action.payload.geogebra && action.payload;
            if (receivedObject) {
                updatedGeogebraExercises = [...updatedGeogebraExercises, receivedObject];
            }
            return {
                ...state,
                geogebraExercises: updatedGeogebraExercises,
            };
        }
        default:
            return state;
    }
});
